/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_table_rows_0_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Launch GridCraft; choosing a sample alone does not start the app.`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_table_rows_0_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击 Launch GridCraft；仅选择示例不会启动应用。`)
};

/**
* | output |
* | --- |
* | "Select Launch GridCraft; choosing a sample alone does not start the app." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_table_rows_0_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_table_rows_0_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_table_rows_0_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_table_rows_0_1 as "gc.search_guides.gridcraft_online.sections.3.table.rows.0.1" }